import $ from 'jquery';

export default {
	init() {
    // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

    function handleStickyItems() {
      const stickyItems = document.querySelectorAll(".sticky-row-content > .sticky-section");
      const stickyImageContainer = document.querySelector(".sticky-image-container");
      const stickyImages = stickyImageContainer.querySelectorAll(".sticky-image-inner");

      if (!stickyItems) return;
      stickyItems.forEach((stickyItem, index) => {
        console.log("🚧 index: ", index);
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                //stickyItem.classList.add("is-visible");
                stickyImages[index].classList.add("active");
                // get index
              } else {
                stickyImages[index].classList.remove("active");
                //stickyItem.classList.remove("is-visible");
              }
            });
          },
          {
            threshold: 0.65,
          }
        );
        observer.observe(stickyItem);
      });
    }

    var stickyBlockExists = document.querySelector(".block-sticky-image");
    if (window.innerWidth > 767 && stickyBlockExists) {
      handleStickyItems();
    }
  },
	finalize() {},
};